
import { Component, Prop, Vue } from "vue-property-decorator";
import { ContactType } from "@/core/CommonDefinition";
import ContactEditeur from "@/core/ContactEditeur";
import { rulesForms } from "@/core/RulesForm";

@Component
export default class Contact extends Vue {
  @Prop() contact!: ContactEditeur;
  rulesForms: any = rulesForms;

  typeContactCandidates: Array<ContactType> = [
    ContactType.COMMERCIAL,
    ContactType.TECHNIQUE
  ];
  typeContactCandidatesLabel: Array<string> = [];

  constructor() {
    super();
    for (const type in this.typeContactCandidates) {
      this.typeContactCandidatesLabel.push(ContactType[type].toLowerCase());
    }
  }

  remove(): void {
    this.$emit("onChange"); // On notifie le composant parent
  }

  validate(): boolean {
    return (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
  }

  clear(): void {
    (this.$refs.form as HTMLFormElement).resetValidation();
  }
}
